import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div className="mobileapp_gcc p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banenr_content">
              <h2>Business Empowering Ecommerce App Development Services</h2>
              <p>
                The world is currently witnessing an e-commerce boom, and do you
                know what's driving this boom? Ecommerce Apps!
              </p>
              <p>
                E-commerce helps drive maximum conversions to your business by
                becoming a single point where customers can view all of your
                products and their related information with easy payment
                methods.
              </p>
              <p>
                As a leading ecommerce mobile app development company, TekRevol
                has played its part in allowing businesses to gain an impressive
                increase in conversions and engagement.
              </p>
              <p>
                With its quality-enriched e-commerce mobile app development
                services, clients can see their app ideas transit into reality.
              </p>
              <p>
                We have an in-house team of e-commerce app developers who know
                exactly how to structure these types of apps to drive home a
                stellar experience for users. TekRevol is hands down your go-to
                place for ecommerce application development services.
              </p>

              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <StaticImage
              src="../../../images/solution/ecommerce/Business-Empowering-Ecommerce-App.webp"
              alt="ecommerce app development services"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
